import * as React from 'react'
import styled from 'styled-components'
import {raise, Intent, getBackgroundColor} from '../theme'

interface IProps {
  className?: string
  title?: string | React.ReactNode
  action?: React.ReactNode
  type?: Intent
  loading?: boolean
  backgroundColor?: boolean
  children?: React.ReactNode
}
class CardClass extends React.PureComponent<IProps> {
  static defaultProps: Pick<IProps, 'type' | 'loading'> = {
    type: 'neutral',
    loading: false
  }
  render() {
    return (
      <div className={this.props.className}>
        {!this.props.loading && (
          <>
            {this.props.title && <Title>{this.props.title}</Title>}
            {this.props.action && <Action>{this.props.action}</Action>}
            {this.props.children}
          </>
        )}
      </div>
    )
  }
}

const Title = styled.h3`
  display: flex;
  height: 60px;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
  font-weight: 600;
  margin: 0;
  color: #a04191;
`

const Action = styled.div`
  position: absolute;
  top: 11px;
  right: 13px;
`
export const Card = styled(CardClass)`
  position: relative;
  padding: 0.5rem;
  background-color: ${props => (props.backgroundColor ? getBackgroundColor(props.type!) : '#ffe2e2')};
  border-radius: 4px;
  min-height: 90px;
  ${raise(1)};
  color: ${props => getTextColor(props.type!)};
  margin-bottom: 10px;
`

export function getTextColor(type: Intent) {
  switch (type) {
    case 'error':
      return '#d11f1f'
    case 'warning':
      return '#9b6d28'
    case 'success':
      return '#3b681e'
    case 'lightSuccess':
      return '#3b681e'
    default:
      return '#444'
  }
}
